export const defaultOptions = {
    clearArray: false,
    clearOnNavigate: true,
    clearAfterMs: 0,
    flashCookieOptions: {
        path: '/',
        maxAge: 120,
        httpOnly: false,
        sameSite: 'strict'
    }
};
export function mergeOptions(parentOptions, options) {
    return {
        ...parentOptions,
        ...options,
        flashCookieOptions: {
            ...parentOptions.flashCookieOptions,
            ...options?.flashCookieOptions
        }
    };
}
